import React, { useMemo } from 'react';

import { fg } from '@confluence/feature-gating';
import { type ChatAction, HandleActionType } from '@atlassian/rovo-conversation-actions/types';

const CONVO_STARTER_NUDGE_ID = 'convo-starter';

/**
 * Hook that creates and returns the convo starters nudge action placeholder.
 * The title and prompt are intentionally empty — they are enriched from the BE
 * recommendation payload at match time via enrichConversationStarterNudge in enrichNudge.
 */
export function useConvoStartersNudgeAction(): ChatAction | null {
	return useMemo(() => {
		if (!fg('aix_convo_starter_nudge_enabled')) {
			return null;
		}
		return {
			id: CONVO_STARTER_NUDGE_ID,
			title: '',
			type: 'convo-starter-action',
			handleType: HandleActionType.Chat,
			icon: () => <></>,
			staticPrompt: '',
			starterType: 'static',
		};
	}, []);
}
